<div class="registration-provider-authentication">
  <h2>{{ 'fgbcl.registration.provider.auth.title' | translate: { fgbdefault: 'Provider Authentication' } }}</h2>
  <p
    class="registration-provider-authentication-instruction"
    [innerHtml]="
      'fgbcl.registration.provider.auth.instruction'
        | translate: { fgbdefault: 'Please enter your third party username and password to link your accounts.' }
        | markdownTranslate
    "
  ></p>

  <fgbcl-errors></fgbcl-errors>

  <div class="form-floating mb-3">
    <input type="text" class="form-control" id="username" [(ngModel)]="username" />
    <label for="username">{{ 'fgbcl.registration.provider.auth.username.label' | translate: { fgbdefault: 'Username' } }}</label>
  </div>

  <div class="form-floating mb-3">
    <input type="password" class="form-control" id="password" [(ngModel)]="password" />
    <label for="password">{{ 'fgbcl.registration.provider.auth.password.label' | translate: { fgbdefault: 'Password' } }}</label>
  </div>

  <div class="navigation-button-wrapper">
    <fgbcl-registration-navigation (nextButtonClicked)="submitStep()" [stepType]="stepType"></fgbcl-registration-navigation>
  </div>
</div>
